import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../../data.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import{ GlobalConstant } from '../../../constants/global-constant';
import { NotificationService } from "../../../services/notification.service";

import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from "../../dialog/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'app-edu-sys-view',
  templateUrl: './edu-sys-view.component.html',
  styleUrls: ['./edu-sys-view.component.css']
})
export class EduSysViewComponent implements OnInit {
  records: Array<any>;
  statusData: Array<any> =[];
  itemPerPageSelection: any = '5';
  
  config:any = {
      itemsPerPage: 5,
      currentPage: 1,
      totalItems: 0
    };

  constructor(private router: Router, public appData: AppData, private dataService: DataService,
  			public dialog: MatDialog,
  			public notificationService: NotificationService) { }

  public pageChanged(event){
    this.config.currentPage = event;
    //console.log(this.config);
    //this.dataService.sendPostRequest(UrlConstant.apiGetEducationalSystem).subscribe((res: any)=>{
  	let req:any = {"pageNumber": this.config.currentPage -1, "recordsPerPage": this.config.itemsPerPage};
  	if(this.appData.userId=='Admin' ){
  	  	req.baseData = "allStatus";
  	}
  	if(this.appData.userId!='Admin' && this.appData.user!= null && this.appData.user.getValue().createdForCompany != undefined)
  	    req.id = this.appData.user.getValue().createdForCompany;
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystemCount, req).subscribe((res: any)=>{
      //console.log(res);
      this.config.totalItems = res.data;
    });
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystem, req).subscribe((res: any)=>{
      //console.log(res);
      this.records = res.data;
      res.data.forEach(r =>{
		  this.statusData.push({'status': r.status}) ;
	  });
    });
    
  }
  
  ngOnInit(): void {
	//console.log(this.appData.user.getValue().createdForCompany);
	this.appData.user.subscribe(message=> {
		//console.log("edu-sys-view::this.appData.userId:"+this.appData.userId+", this.appData.user:"+this.appData.user.getValue());
		if(message!==null)
			this.pageChanged(1);
	});
    
  	
  }


  public deleteEducationSystem(id){
  	console.log('hi');
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiDeleteEducationalSystem, {"id":id}).subscribe((res: any)=>{
      console.log(res);
      if("SUCCESS" === res.status){
      	console.log("Record Deleted Successfully");
  	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystem, {}).subscribe((res: any)=>{
	      console.log(res);
	      this.records = res.data;
	    });
      	//this.router.navigate(['/dashboard', { 'userId': '' }]);
      } else  if("FAIL" === res.status){
		  if(res.message)
		  	this.notificationService.error(res.message);
	  }
      //if("SUCCESS" === res.status || "FAIL" === res.status ){
      	
    });
  }
  
  public changeStatus(itemDetail){
	  
	  var reqBody = {'id':itemDetail.id, 'status': itemDetail.status, 'owner':{'id':itemDetail.owner.id, 'loginUserId': itemDetail.owner.loginUserId} };
	   this.dataService.sendPostRequestWithBody(UrlConstant.apiUpdateEducationalSystem ,reqBody).subscribe((data: any)=>{
		 		console.log(data);
			      if("SUCCESS" === data.status){
					  this.notificationService.success("Status modified Succcessfully");
				} else {
			        console.log("fail code");
			        this.notificationService.error(data.message);
		      		//this.router.navigate(['/dashboard', { 'userId': username }]);
			      }
			   });
  }
  public changeStatusConfirmation(itemIndex, itemDetail, event) {
	 //console.log(itemDetail)
	 //console.log(event)
	 //return;
	 let config = this.dataService.getShallowClone(GlobalConstant.confirmDialogConfig);
	  config.data= this.dataService.getShallowClone(GlobalConstant.confirmDialogConfig.data);
	  config.data.title = 'Are you sure';
	  config.data.message = "Do you want to change status to '"+itemDetail.status+"' ?";
	  //const dialogRef = this.dialog.open(ConfirmationDialogComponent, GlobalConstant.confirmDialogConfig);
	  const dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
	  dialogRef.afterClosed().subscribe(dialogResult => {
	      if(dialogResult == true){
			 this.changeStatus(itemDetail);
		  } else {
			  itemDetail.status = this.statusData[itemIndex].status;
		  }
	    });
	    
//     this.notificationService.confirmation("Do you want to change status to '"+itemDetail.status+"'", () => {
  //   	this.changeStatus(itemDetail);
    // },
    // 'Are you sure?',
//      () => {
	//	  itemDetail.status = this.statusData[itemIndex].status;
       //this.notificationService.error("confirm canceled");
     //});
  }
  public changeItemSelectionData(itemSelectionData, event){
	  this.config.itemsPerPage = itemSelectionData;
	  this.pageChanged(this.config.currentPage);
  }
}
